import React, { FormEventHandler, useEffect, useState } from 'react';
import { ContainerWrapper, MobileVerificationInputWrapper, ParentContainer, Row } from './styles';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import RenderCommonDropdownField from '../../../../components/form-controls/outlinedDropdown';
import { ModalFactory } from '../../../../components/modal/modal';
import OtpModal from './otpVerification/OtpModal';
import { auMobValidation, dynamicMobileValidation } from '../../../../utils/validation';
import { connect } from 'react-redux';
import { IStore } from '../../../../store.type';
import Header from './components/Header';
import { getMobileCodeByCountry } from '../../../../redux/actions/common/common-action';
import { initializeForm } from '../../../../utils/library';
import {
  FLOW_TYPE_ONBOARDING,
  MOBILE_NUMBER_FILLED,
  MOBILE_NUMBER,
  SIGNUP,
  NF_MOBILE_NUMBER_FILLED
} from '../../../../utils/constants/eventsConstants';
import {
  getCMSStepperData,
  getInputFieldByName,
  getScreensData,
  ROUTE_KEYS,
  getContentCountryCode
} from './utils/Util';
import { OnboardingStepperCmsData } from './utils/Interface';
import {
  activateLoader,
  disableLoader
} from '../../../../redux/actions/ui-trigger/ui-trigger-action';
import { getPhoneValidationsByCountry } from '../../../../redux/actions/otp-request/otp-request-action';
import { OutlinedTextFields } from '../../../../components/material-textField/texField';
import {
  normalizeAll,
  r_maxLength,
  r_onlyNumbers
} from '../../../../utils/validation/restrictions';
import { mobileVerificationFields } from './utils/constants';
import { omit } from 'lodash';
import CommonButton from '../../../../components/common-button/CommonButton';
import { logEvent } from '../../../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../../../utils/events/eventsConstants';
import { MOBILE_NUMBER_ONBOARDING_ICON } from '@Images';

const FORM_NAME = 'mobileNumber';
const MOBILE_NUMBER_FORM = {
  code: '',
  phone: ''
};

type MobileVerificationPropTypes = {
  handleSubmit: (func: any) => FormEventHandler<HTMLElement> | undefined;
  countryCode: string;
  mobileNumber: string;
  getMobileCodeByCountry: (countryCode: string, isSignUpFlow: boolean) => any;
  activateLoader: any;
  disableLoader: any;
  getPhoneValidationsByCountry?: any;
  mobileValidationReducer?: any;
  initialize: (data: any) => void;
  isNiumForexUser?: boolean;
};

const NewMobileVerificationFlowForm = ({
  countryCode,
  mobileNumber,
  handleSubmit,
  getMobileCodeByCountry,
  activateLoader,
  disableLoader,
  getPhoneValidationsByCountry,
  initialize,
  // this is required for dynamicMobileValidation
  mobileValidationReducer,
  isNiumForexUser
}: MobileVerificationPropTypes): React.ReactElement => {
  const [mobileCountryCode, setmobileCountryCode] = useState<string>('');
  const [cmsData, setCMSData] = useState<OnboardingStepperCmsData | undefined>();
  const [cmsInputFields, setCMSInputFields] = useState<any>({});
  const ctData = {
    pageName: MOBILE_NUMBER
  };

  const contentCountryCode = getContentCountryCode(countryCode);
  const screenData = getScreensData(ROUTE_KEYS.MobileNumberScreen, contentCountryCode);
  const stepperData = screenData?.stepperData;

  const getCMSData = async () => {
    const stepperCmsData = await getCMSStepperData(
      ROUTE_KEYS.MobileNumberScreen,
      contentCountryCode
    );
    const inputFields = stepperCmsData?.inputFields;
    const stepperData = omit(stepperCmsData, 'inputFields');
    setCMSData(stepperData);
    setCMSInputFields({
      mobileNumber:
        getInputFieldByName(inputFields, 'MOBILE_NUMBER_FIELD') ||
        mobileVerificationFields['MOBILE_NUMBER_FIELD']
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      getPhoneValidationsByCountry(countryCode, false);
      activateLoader();
      await getMobileCountryCode();
      await getCMSData();

      const initialData = {
        code: countryCode,
        phone: mobileNumber
      };
      initialize(initializeForm(MOBILE_NUMBER_FORM, initialData));

      disableLoader();
    };

    fetchData();
    //eslint-disable-next-line
  }, []);

  const mobileCountryCodeOptions = [
    {
      value: mobileCountryCode,
      text: mobileCountryCode
    }
  ];

  const getMobileCountryCode = async () => {
    const response = await getMobileCodeByCountry(countryCode, false);
    if (response?.data?.data[0]?.code) {
      const code = response.data.data[0].code;
      setmobileCountryCode(`+${code}`);
    }
  };

  const onSubmit = ({ phone = '', code: _code = '' }: any) => {
    const eventName = isNiumForexUser ? NF_MOBILE_NUMBER_FILLED : MOBILE_NUMBER_FILLED;
    const flowType = isNiumForexUser ? SIGNUP : FLOW_TYPE_ONBOARDING;
    const errors: any = {};
    let isError = false;
    if (!phone.trim()) {
      errors.phone = 'Mobile number is required';
      isError = true;
    }
    if (isError) {
      throw new SubmissionError(errors);
    } else {
      logEvent(eventName, flowType, ctData, LOG_TYPE.CLEVER_TAP);
      triggerOtpModal(phone);
    }
  };

  const triggerOtpModal = async (phoneValue: string) => {
    //@ts-ignore
    await ModalFactory.builder(
      (onClose: any) => (
        <>
          <OtpModal
            // @ts-ignore
            onClose={onClose}
            inputPhoneNumber={phoneValue}
            mobileCountryCode={mobileCountryCode}
            isNiumForexUser={isNiumForexUser}
            countryCode={countryCode}
            formID={FORM_NAME}
          />
        </>
      ),
      'send-money-bene-modal insta-modal center-modal',
      true
    );
  };

  return (
    <ContainerWrapper>
      <ParentContainer padding={[48, 0]} isNiumForexUser={isNiumForexUser}>
        <Header
          heading={cmsData?.heading || ''}
          headerLogo={MOBILE_NUMBER_ONBOARDING_ICON}
          stepNumber={stepperData?.stepNumber}
          totalSteps={stepperData?.totalSteps}
          subHeading={cmsData?.description || ''}
        />
        <div className="form-container">
          <form id={FORM_NAME} onSubmit={handleSubmit(onSubmit)}>
            <MobileVerificationInputWrapper>
              <Field
                bindToThisObject={mobileCountryCode}
                className="dropdown"
                placeholder="Code"
                type="text"
                name="code"
                component={RenderCommonDropdownField}
                disabled
                staticValues={mobileCountryCodeOptions}
                width={134}
              />
              <Field
                placeholder={cmsInputFields?.mobileNumber?.label}
                name="phone"
                type="text"
                component={OutlinedTextFields}
                showLabel={false}
                disableUnderlineStyling={true}
                validate={countryCode === 'AU' ? [auMobValidation] : [dynamicMobileValidation]}
                normalize={(() => {
                  const restrictions = [];
                  if (mobileValidationReducer) {
                    if (mobileValidationReducer.type === 'startsWithFour')
                      restrictions.push(r_onlyNumbers);
                    if (mobileValidationReducer.length) {
                      const { max, exact } = mobileValidationReducer.length;
                      restrictions.push(r_maxLength(exact || max));
                    }
                    if (mobileValidationReducer.type === 'number') restrictions.push(r_onlyNumbers);
                    if (mobileValidationReducer.length) {
                      const { max, exact } = mobileValidationReducer.length;
                      restrictions.push(r_maxLength(exact || max || 50));
                    }
                  }
                  return normalizeAll(restrictions);
                })()}
              />
            </MobileVerificationInputWrapper>
            <Row padding={[48, 0, 0, 0]}>
              <CommonButton text={cmsData?.primaryBtnText || ''} width={450} height={46} />
            </Row>
          </form>
        </div>
      </ParentContainer>
    </ContainerWrapper>
  );
};

const NewMobileVerificationFlow = reduxForm<any, any>({
  form: FORM_NAME
})(NewMobileVerificationFlowForm);

function mapStateToProps(reduxState: IStore) {
  const {
    rootReducer: {
      userStatusReducer: {
        country_code: countryCode,
        remitter_individual_mobile_number: mobileNumber
      },
      // this is required for dynamicMobileValidation
      mobileValidationReducer,
      niumForexReducer: { isNiumForexUser }
    }
  } = reduxState;

  return { countryCode, mobileNumber, mobileValidationReducer, isNiumForexUser };
}

export default connect<any, any, any, IStore>(mapStateToProps, {
  getMobileCodeByCountry,
  activateLoader,
  disableLoader,
  getPhoneValidationsByCountry
})(NewMobileVerificationFlow);
